export default function toDigit(value) {
  if (!value) {
    return value;
  }

  return value.match?.(/[0-9]+/g)?.join('');
}
